import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14036 6.53335L7.47813 3.36668H9.18698L8.8492 6.53335H11.3626L11.7004 3.36668H13.4092L13.0714 6.53335H14.8778V8.24446H12.8912L12.6401 10.7556H14.8778V12.4667H12.4596L12.1219 15.6333H10.413L10.7508 12.4667H8.23742L7.89964 15.6333H6.1908L6.52858 12.4667H4.72222V10.7556H6.70878L6.95989 8.24446H4.72222V6.53335H7.14036ZM11.1821 8.24446H8.669L8.41789 10.7556H10.931L11.1821 8.24446Z"
      fill="#222A5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.41111 0.200012H17.1889C17.6957 0.200012 18.1818 0.401361 18.5402 0.759764C18.8987 1.11817 19.1 1.60427 19.1 2.11112V16.8889C19.1 17.3958 18.8987 17.8819 18.5402 18.2403C18.1818 18.5987 17.6957 18.8 17.1889 18.8H2.41111C1.90425 18.8 1.41815 18.5987 1.05975 18.2403C0.701349 17.8819 0.5 17.3958 0.5 16.8889V2.11112C0.5 1.60427 0.701349 1.11817 1.05975 0.759764C1.41815 0.401361 1.90425 0.200012 2.41111 0.200012ZM17.2889 17.0889V1.91112H2.21111V17.0889H17.2889Z"
      fill="#222A5C"
    />
  </svg>,
  "Short Code"
);
